// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MODAL CONTAINER */

.disclaimer-background{
    position: fixed;
    top: 80px;
    left: 0;
    align-self: center;
    width: 100%;
    height: calc(100% - 80px);
    background: rgba(0, 0, 0, 0.3);
    z-index: 999 !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.disclaimer-content-container{
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 40%;
    height: fit-content;
    background-color: var(--white-base);
    border-radius: 20px;
}

.disclaimer-content-inner-container{
    margin: 20px;
}

.disclaimer-header-title{
    position: relative;
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 44px; /* 129.412% */
    letter-spacing: -0.56px;
}

.disclaimer-information{
    position: relative;
    height: 100%;
    margin-top: 20px;
    overflow-y: auto;
    text-align: center;

    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.12px;
}

.disclaimer-decission-container{
    position: relative;
    display: flex;
    margin-top: 10%;
    flex-direction: row;
    gap: auto;
}

.disclaimer-button {
    position: relative;
    display: flex;
    justify-content: center;
    align-self: center;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    width: fit-content;
    border-radius: 20px;
    background-color: var(--border);
    padding: 0px 15px;
    -webkit-user-select: none;
            user-select: none;
    color: var(--white-base);

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
}

.disclaimer-left-button-nein{
    position: relative;
    width: 15%;
    margin-left: 20px;
    background-color: var(--assessment-lv1);
}

.disclaimer-right-button-ja{
    position: relative;
    width: 15%;
    margin-right: 20px;
    background-color: var(--assessment-lv4)
}

.disclaimer-left-button{
    position: relative;
    margin-left: 20px;
    background-color: var(--border);
}

.disclaimer-right-button{
    position: relative;
    width: fit-content;
    margin-right: 20px;
    background-color: var(--blue-50)
}


.disclaimer-close-button {
    position: absolute;
    z-index: 1;
    width: 35px;
    height: 35px;
    top: 10px;
    right: 10px;
    color: var(--white-base);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    font-size: 24px;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    text-align: center;
}

.disclaimer-close-button:hover {
    transform: scale(1.01);
    /* Scale up the button on hover */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
    /* Increase shadow on hover for a lifted effect */
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    /* Smooth transition for a polished feel */
}`, "",{"version":3,"sources":["webpack://./src/widgets/ModalDisclamer.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;IAElB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,wBAAwB;;IAExB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,eAAe;IACf,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,wCAAwC;IACxC,iDAAiD;IACjD,iFAAiF;IACjF,0CAA0C;AAC9C","sourcesContent":["/* MODAL CONTAINER */\r\n\r\n.disclaimer-background{\r\n    position: fixed;\r\n    top: 80px;\r\n    left: 0;\r\n    align-self: center;\r\n    width: 100%;\r\n    height: calc(100% - 80px);\r\n    background: rgba(0, 0, 0, 0.3);\r\n    z-index: 999 !important;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.disclaimer-content-container{\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-self: center;\r\n    width: 40%;\r\n    height: fit-content;\r\n    background-color: var(--white-base);\r\n    border-radius: 20px;\r\n}\r\n\r\n.disclaimer-content-inner-container{\r\n    margin: 20px;\r\n}\r\n\r\n.disclaimer-header-title{\r\n    position: relative;\r\n    font-family: Inter;\r\n    font-size: 28px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 44px; /* 129.412% */\r\n    letter-spacing: -0.56px;\r\n}\r\n\r\n.disclaimer-information{\r\n    position: relative;\r\n    height: 100%;\r\n    margin-top: 20px;\r\n    overflow-y: auto;\r\n    text-align: center;\r\n\r\n    font-family: Inter;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 24px; /* 150% */\r\n    letter-spacing: 0.12px;\r\n}\r\n\r\n.disclaimer-decission-container{\r\n    position: relative;\r\n    display: flex;\r\n    margin-top: 10%;\r\n    flex-direction: row;\r\n    gap: auto;\r\n}\r\n\r\n.disclaimer-button {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-self: center;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    cursor: pointer;\r\n    width: fit-content;\r\n    border-radius: 20px;\r\n    background-color: var(--border);\r\n    padding: 0px 15px;\r\n    user-select: none;\r\n    color: var(--white-base);\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n    text-align: center;\r\n}\r\n\r\n.disclaimer-left-button-nein{\r\n    position: relative;\r\n    width: 15%;\r\n    margin-left: 20px;\r\n    background-color: var(--assessment-lv1);\r\n}\r\n\r\n.disclaimer-right-button-ja{\r\n    position: relative;\r\n    width: 15%;\r\n    margin-right: 20px;\r\n    background-color: var(--assessment-lv4)\r\n}\r\n\r\n.disclaimer-left-button{\r\n    position: relative;\r\n    margin-left: 20px;\r\n    background-color: var(--border);\r\n}\r\n\r\n.disclaimer-right-button{\r\n    position: relative;\r\n    width: fit-content;\r\n    margin-right: 20px;\r\n    background-color: var(--blue-50)\r\n}\r\n\r\n\r\n.disclaimer-close-button {\r\n    position: absolute;\r\n    z-index: 1;\r\n    width: 35px;\r\n    height: 35px;\r\n    top: 10px;\r\n    right: 10px;\r\n    color: var(--white-base);\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    font-size: 24px;\r\n    display: flex;\r\n    justify-content: center; /* Center horizontally */\r\n    align-items: center; /* Center vertically */\r\n    text-align: center;\r\n}\r\n\r\n.disclaimer-close-button:hover {\r\n    transform: scale(1.01);\r\n    /* Scale up the button on hover */\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\r\n    /* Increase shadow on hover for a lifted effect */\r\n    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;\r\n    /* Smooth transition for a polished feel */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
